import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	draggableItemLabel: {
		id: 'cmdb-pragmatic-dnd-tree.tree-item-draggable.draggable-item-label',
		description: 'aria-label for the draggable page tree item',
		defaultMessage: '{title} draggable item',
	},
});
